module.exports = __webpack_public_path__ + "img/padlock.c93cbb2a.png";